import { render } from "./UpdateStatusPedido.vue?vue&type=template&id=755bb1c8&scoped=true"
import script from "./UpdateStatusPedido.vue?vue&type=script&lang=js"
export * from "./UpdateStatusPedido.vue?vue&type=script&lang=js"

import "./UpdateStatusPedido.vue?vue&type=style&index=0&id=755bb1c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755bb1c8"]])

export default __exports__